import validate, {
  listOfFormsAreValidated,
} from 'containers/services/validateForm';
import { JUDGEMENT_ADD_DOCUMENT, EXPERTISE } from 'containers/data-structure';
import { get, isEmpty } from 'lodash';
import {
  Expertise,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { addDaysToDate } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';

export const judgementAddConstraints = () => {
  return {
    [JUDGEMENT_ADD_DOCUMENT.JUDGEMENT_DATE]: {
      presence: true,
    },
    [JUDGEMENT_ADD_DOCUMENT.RESPONSABILITY_SHARE]: {
      presence: true,
    },
  };
};

export const judgementAddValidator = (
  judgementAdd: JudgementADDDocumentType,
) => {
  return validate(judgementAdd, judgementAddConstraints());
};

export const expertiseConstraints = () => {
  return {
    [EXPERTISE.EXPERTISE_ID]: {
      presence: true,
    },
  };
};

export const expertiseValidator = (expertise: Expertise) => {
  return validate(expertise, expertiseConstraints());
};

export const expertisesValidator = (expertises: Expertise[]) => {
  const validateList = expertises.map(expertise =>
    expertiseValidator(expertise),
  );
  return listOfFormsAreValidated(validateList);
};

export const isJudgementValid = (
  judgementAddDocument: JudgementADDDocumentType,
  hearingDate: Date,
) => {
  const victims = judgementAddDocument.expertises.map(e => e.victims).flat();
  const vehicules = judgementAddDocument.expertises
    .map(e => e.vehicules)
    .flat();
  const expertises = judgementAddDocument.expertises;
  const validateExpertises = expertisesValidator(expertises);

  const validateJudgementAdd = !judgementAddValidator(judgementAddDocument);
  const isJudgementDateValid =
    get(judgementAddDocument, 'judgementDate', null) !== 'Invalid date' &&
    !(
      new Date(addDaysToDate((hearingDate as any) || '', 0) || '') >
        new Date(get(judgementAddDocument, 'judgementDate') || '') ||
      new Date(get(judgementAddDocument, 'judgementDate') || '') > new Date()
    );
  return (
    isJudgementDateValid &&
    validateExpertises &&
    validateJudgementAdd &&
    !isEmpty([...victims, ...vehicules])
  );
};
